
import Vue from 'vue';
import ListItem from '@/components/base/ListItem.vue';
import { UPSELL_TYPE } from '@/constants/constants';
import { mapGetters, mapState } from 'vuex';
import TeamPicker from '@/components/TeamPicker.vue';

export default Vue.extend({
	name: 'RdBorderCardUpsell',
	props: {
		containerStyles: { type: Object, default: () => {} },
		creatorsClubTitleOverride: { type: String, default: null },
		upsellType: { type: String, required: true },
		emphasizeRecurringBalance: { type: Boolean, default: false },
		hover: { type: Boolean, default: false },
		hideTeamPicker: { type: Boolean, default: false },
	},
	computed: {
		...mapState([
			'team',
		]),
		...mapGetters([
			'displayLabels',
			'companyClubOfferBenefits',
		]),
		isTeamUpsell () {
			return this.upsellType === UPSELL_TYPE.TEAM;
		},
		isCreatorsClubUpsell () {
			return this.upsellType === UPSELL_TYPE.CREATORS_CLUB;
		},
		creatorsClubTitle () {
			return this.creatorsClubTitleOverride || '*Creator\'s Club Required';
		},
		teamTitle () {	
			if (this.companyClubOfferBenefits.isEnterprise) return `${this.displayLabels.team} Deactivated`;
			return '*Active Team Plan Required';
		},
	},
	components: {
		TeamPicker,
		ListItem,
	},
});
